import React from 'react';
import Loader from './Loader';
import { BannerHolder } from '../StyledComponents/BannerHolder';

const BannerLoader = () => {
  return (
    <BannerHolder>
      <Loader />
    </BannerHolder>
  );
};

export default BannerLoader;
